import { styled } from "styled-components";
import { Column } from "../../../components/ui/grid/column.component";
import { Row } from "../../../components/ui/grid/row.component";
import { SectionTitle } from "../../../components/ui/section-title/section-title.component";
import { TextButton } from "../../../components/ui/text-button/text-button.component";
import { Spacer } from "../../../components/ui/spacer/spacer.component";
import { Alert } from "../components/alert.component";
import { LinkingAlert } from "../../../models/linking-alert.model";
import { colors } from "../../../theme/colors";

export const AlertsSection = ({ alerts }: { alerts: LinkingAlert[] }) => {
  return (
    <Main>
      <Spacer direction="bottom" size={30} />
      <Row style={{ width: "100%", justifyContent: "space-between" }}>
        <SectionTitle>Alerts</SectionTitle>
        <TextButton onClick={() => null} color="complement">
          View All &rarr;
        </TextButton>
      </Row>
      <Spacer direction="bottom" size={10} />
      <ItemRow>
        {alerts.length === 0 ? <NoResultsText>No Alerts!</NoResultsText> : null}
        {alerts.map((alert) => (
          <Alert key={alert.id} alert={alert} />
        ))}
      </ItemRow>
    </Main>
  );
};

const NoResultsText = styled.h3`
  font-size: 1.4rem;
  font-weight: 600;
  color: ${colors.text.hex};
  opacity: 0.6;
`;

const Main = styled(Column)`
  max-width: 100%;
  align-items: start;
`;

const ItemRow = styled(Row)`
  width: 100%;
  max-width: 100%;
  gap: 1rem;
  overflow-x: auto;
  padding: 6rem 0;
  margin: -6rem 0;
`;
